export const GET_USER_POLICIES = 'GET_USER_POLICIES';
export const GET_USER_POLICIES_SUCCESS = 'GET_USER_POLICIES_SUCCESS';
export const GET_USER_POLICIES_FAILURE = 'GET_USER_POLICIES_FAILURE';
export const POST_USER_POLICY = 'POST_USER_POLICY';
export const POST_USER_POLICY_SUCCESS = 'POST_USER_POLICY_SUCCESS';
export const POST_USER_POLICY_FAILURE = 'POST_USER_POLICY_FAILURE';
export const UPDATE_USER_POLICY = 'UPDATE_USER_POLICY';
export const UPDATE_USER_POLICY_SUCCESS = 'UPDATE_USER_POLICY_SUCCESS';
export const UPDATE_USER_POLICY_FAILURE = 'UPDATE_USER_POLICY_FAILURE';
export const DELETE_USER_POLICY = 'DELETE_USER_POLICY';
export const DELETE_USER_POLICY_SUCCESS = 'DELETE_USER_POLICY_SUCCESS';
export const DELETE_USER_POLICY_FAILURE = 'DELETE_USER_POLICY_FAILURE';
export const RUNNING_LOADER_USER_POLICY = 'RUNNING_LOADER_USER_POLICY';
export const GET_DOWN_TIME_OBJECT_DEFAULT = 'GET_DOWN_TIME_OBJECT_DEFAULT';
export const GET_DOWN_TIME_OBJECT_DEFAULT_SUCCESS = 'GET_DOWN_TIME_OBJECT_DEFAULT_SUCCESS';
export const GET_DOWN_TIME_OBJECT_DEFAULT_FAILURE = 'GET_DOWN_TIME_OBJECT_DEFAULT_FAILURE';
export const CLEAR_USER_POLICY_OPERATION_RESULT = 'CLEAR_USER_POLICY_OPERATION_RESULT';
export const GET_NAVIGATION_HISTORY = 'GET_NAVIGATION_HISTORY';
export const FAILURE_NAVIGATION_HISTORY = 'FAILURE_NAVIGATION_HISTORY';
export const ADD_TIME_LIMIT_NODE_POLICY = 'ADD_TIME_LIMIT_NODE_POLICY';
export const ADD_TIME_LIMIT_NODE_POLICY_SUCCESS = 'ADD_TIME_LIMIT_NODE_POLICY_SUCCESS';
export const ADD_TIME_LIMIT_NODE_POLICY_FAILURE ='ADD_TIME_LIMIT_NODE_POLICY_FAILURE';

//chat action

export const GET_USERS_LIST_ERROR_CommunityReach = 'GET_USERS_LIST_ERROR_CommunityReach';
export const GET_ROOM_DATA_CommunityReach = "GET_ROOM_DATA_CommunityReach";
export const GET_MESSAGES_CommunityReach = 'GET_MESSAGES_CommunityReach';
export const GET_MESSAGES_ERROR_CommunityReach = 'GET_MESSAGES_ERROR_CommunityReach';
export const SEND_MESSAGE_CommunityReach = 'SEND_MESSAGE_CommunityReach';
export const DELETE_MESSAGE_CommunityReach = 'DELETE_MESSAGE_CommunityReach';
export const SEND_DIRECT_MESSAGE_CommunityReach = 'SEND_DIRECT_MESSAGE_CommunityReach';
export const DELETE_DIRECT_MESSAGE_CommunityReach = 'DELETE_DIRECT_MESSAGE_CommunityReach';
export const UPDATE_MESSAGE_CommunityReach = "UPDATE_MESSAGE_CommunityReach";
export const GET_JOINED_CHANNELS_LIST_CommunityReach = 'GET_JOINED_CHANNELS_LIST_CommunityReach';
export const GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach = 'GET_JOINED_CHANNELS_LIST_ERROR_CommunityReach';
export const CREATE_CHANNEL_CommunityReach = 'CREATE_CHANNEL_CommunityReach';
export const CREATE_CHANNEL_CommunityReach_LOADING = "CREATE_CHANNEL_CommunityReach_LOADING";
export const CREATE_CHANNEL_CommunityReach_ERROR = "CREATE_CHANNEL_CommunityReach_ERROR";
export const GET_AUTOCOMPLETE_USERS_LIST_CommunityReach = 'GET_AUTOCOMPLETE_USERS_LIST_CommunityReach';
export const GET_AUTOCOMPLETE_USERS_LIST_ERROR_CommunityReach = 'GET_AUTOCOMPLETE_USERS_LIST_ERROR_CommunityReach';
export const GET_CHAT_USERS_INFO_CommunityReach = 'GET_CHAT_USERS_INFO_CommunityReach';
export const GET_CHAT_USERS_INFO_ERROR_CommunityReach = 'GET_CHAT_USERS_INFO_ERROR_CommunityReach';
export const GET_CHANNEL_INFO_CommunityReach = 'GET_CHANNEL_INFO_CommunityReach';
export const GET_CHANNEL_INFO_ERROR_CommunityReach = 'GET_CHANNEL_INFO_ERROR_CommunityReach';
export const UPLOAD_FILE_TO_ROOM_CommunityReach = 'UPLOAD_FILE_TO_ROOM_CommunityReach';
export const UPLOAD_FILE_TO_ROOM_ERROR_CommunityReach = 'UPLOAD_FILE_TO_ROOM_ERROR_CommunityReach';
export const SET_IS_EDIT_MESSAGE_CommunityReach = "SET_IS_EDIT_MESSAGE_CommunityReach";
export const SET_ENTERED_TEXT_CommunityReach = "SET_ENTERED_TEXT_CommunityReach";
export const CANCEL_IS_EDIT_MESSAGE_CommunityReach = 'CANCEL_IS_EDIT_MESSAGE_CommunityReach';
export const SET_MESSAGE_ID_CommunityReach = 'SET_MESSAGE_ID_CommunityReach';
export const GET_USER_PROFILE_INFO_CommunityReach = "GET_USER_PROFILE_INFO_CommunityReach";
export const GET_USER_PROFILE_INFO_ERROR_CommunityReach = "GET_USER_PROFILE_INFO_ERROR_CommunityReach";
export const UPDATE_MESSAGE_LIST_SO_CommunityReach = "UPDATE_MESSAGE_LIST_SO_CommunityReach";
export const CREATE_DM_CommunityReach = 'CREATE_DM_CommunityReach';
export const CREATE_DM_CommunityReach_LOADING = 'CREATE_DM_CommunityReach_LOADING';
export const CREATE_DM_CommunityReach_ERROR = 'CREATE_DM_CommunityReach_ERROR';
export const CHAT_MEMBERS = 'CHAT_MEMBERS'
export const GET_CHANNEL_MEMBER_INFO_ERROR = 'GET_CHANNEL_MEMBER_INFO_ERROR';
export const GET_PRIVATE_CHAT_INFO_CommunityReach = 'GET_PRIVATE_CHAT_INFO_CommunityReach';
export const GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach = 'GET_PRIVATE_CHAT_INFO_ERROR_CommunityReach'
export const GET_ACTIVE_MESSAGE = 'GET_ACTIVE_MESSAGE'
export const SET_ACTIVE_MESSAGE = 'SET_ACTIVE_MESSAGE'
export const CHANNEL_MEMBERS = 'CHANNEL_MEMBERS'
export const GET_LATEST_CHAT_USER = 'GET_LATEST_CHAT_USER'
export const SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE'
export const LAST_CHAT_ROOM = 'LAST_CHAT_ROOM'

//auth Action
export const LOGIN_LOADER = 'LOGIN_LOADER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERR = 'LOGIN_ERROR';
export const GET_USER_LOADER = 'GET_USER_LOADER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE'



//device Action
export const GET_USER_STATE = 'GET_USER_STATE';
export const GET_STATE_LOADING = 'GET_STATE_LOADING';
export const GET_STATE_ERROR = 'GET_STATE_ERROR';
export const TEAM_USER_SAVE = 'TEAM_USER_SAVE';
export const TEAM_USER_GET = 'TEAM_USER_GET';
export const TEAM_USER_ERROR = '_USER_ERROR';
export const SET_USER = 'SET_USER';
export const GET_DAILY_ACTIVITY_SUCCESS = 'GET_DAILY_ACTIVITY_SUCCESS';

//child schedule
export const GET_ACD_DEVICES_SCHEDULE = 'GET_ACD_DEVICES_SCHEDULE';

//dashboard Action
export const GET_DASHBOARD_HEATMAP = 'GET_DASHBOARD_HEATMAP';
export const GET_DASHBOARD_HEATMAP_LOADING = 'GET_DASHBOARD_HEATMAP_LOADING';
export const GET_DASHBOARD_HEATMAP_ERROR = 'GET_DASHBOARD_HEATMAP_ERROR';
export const GET_DASHBOARD_HEATMAP_BAR_CHART = 'GET_DASHBOARD_HEATMAP_BAR_CHART';
export const GET_DASHBOARD_HEATMAP_BAR_CHART_LOADING = 'GET_DASHBOARD_HEATMAP_BAR_CHART_LOADING';
export const GET_DASHBOARD_HEATMAP_BAR_CHART_ERROR = 'GET_DASHBOARD_HEATMAP_BAR_CHART_ERROR';
export const SET_SELECTED_RANGE = 'SET_SELECTED_RANGE';

//device Action

export const GET_DEVICES_LOADER = 'GET_DEVICES_LOADER';
export const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';
export const GET_DEVICES_ERROR = 'GET_DEVICES_ERROR';
export const GET_ACD_DEVICES_LOADER = 'GET_ACD_DEVICES_LOADER';
export const GET_ACD_DEVICES_SUCCESS = 'GET_ACD_DEVICES_SUCCESS';
export const GET_ACD_DEVICES_ERROR = 'GET_ACD_DEVICES_ERROR';
export const ADD_ACD_LOADER = 'ADD_ACD_LOADER';
export const ADD_ACD_SUCCESS = 'ADD_ACD_SUCCESS';
export const ADD_ACD_ERROR = 'ADD_ACD_ERROR';
export const STATE_CHANGE_LOADING = 'STATE_CHANGE_LOADING';
export const STATE_CHANGE_SUCCESS = 'STATE_CHANGE_SUCCESS';
export const SATE_CHANGE_ERROR = 'SATE_CHANGE_ERROR';
export const ACD_OFF_LOADING = 'ACD_OFF_LOADING';
export const ACD_OFF_SUCCESS = 'ACD_OFF_SUCCESS';
export const ACD_OFF_ERROR = 'ACD_OFF_ERROR';
export const SELECT_ACD_HUB = 'SELECT_ACD_HUB';
export const GET_WEEKLY_APP_LIST_SUCCESS = 'GET_WEEKLY_APP_LIST_SUCCESS';
export const GET_WEEKLY_APP_LIST_FAIL = 'GET_WEEKLY_APP_LIST_FAIL';

//drawer Action
export const HANDLE_DRAWER = 'HANDLE_DRAWER';

//my Result Action
export const SET_WEEKLY_DATA = 'SET_WEEKLY_DATA';
export const SET_HIGHLIGHT_TAB = "SET_HIGHLIGHT_TAB";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";

//notification Action
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAIL = 'GET_NOTIFICATIONS_FAIL';
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
export const GET_NOTIFICATION_FAIL = 'GET_NOTIFICATION_FAIL';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_STATE_SUCCESS = 'UPDATE_NOTIFICATION_STATE_SUCCESS';
export const UPDATE_NOTIFICATION_STATE_FAIL = 'UPDATE_NOTIFICATION_STATE_FAIL';
export const CLOSE_NOTIFICATIONS_WITH_IDS_SUCCESS = 'CLOSE_NOTIFICATIONS_WITH_IDS_SUCCESS';
export const CLOSE_NOTIFICATIONS_WITH_IDS_FAIL = 'CLOSE_NOTIFICATIONS_WITH_IDS_FAIL';
export const SET_LOADING = 'SET_LOADING';

//policy request action
export const GET_POLICYREQUESTS_SUCCESS = 'GET_POLICYREQUESTS_SUCCESS';
export const GET_POLICYREQUESTS_FAIL = 'GET_POLICYREQUESTS_FAIL';
export const POST_POLICYREQUEST_SUCCESS = 'UPDATE_POLICYREQUEST_STATE_SUCCESS';
export const POST_POLICYREQUEST_FAIL = 'UPDATE_POLICYREQUEST_STATE_FAIL';
export const APPROVE_POLICYREQUEST_SUCCESS = 'APPROVE_POLICYREQUEST_SUCCESS';
export const APPROVE_POLICYREQUEST_FAIL = 'APPROVE_POLICYREQUEST_SUCCESS';
export const SHOW_REQUEST_SUCCESS_MODAL = 'SHOW_REQUEST_SUCCESS_MODAL';

//Program action
export const GET_PROGRAM_FORMS_LIST = "GET_PROGRAM_FORMS_LIST";
export const GET_PROGRAM_FORMS_LIST_ERROR = "GET_PROGRAM_FORMS_LIST_ERROR";
export const GET_PROGRAM_FORMS_LIST_LOADING = "GET_PROGRAM_FORMS_LIST_LOADING";
export const GET_PROGRAM_BACKPACK_DATA = "GET_PROGRAM_BACKPACK_DATA";
export const GET_PROGRAM_BACKPACK_DATA_ERROR = "GET_PROGRAM_BACKPACK_DATA_ERROR";
export const GET_PROGRAM_BACKPACK_DATA_LOADING = "GET_PROGRAM_BACKPACK_DATA_LOADING";
export const GET_PROGRAM_ACTION_ITEMS = "GET_PROGRAM_ACTION_ITEMS";
export const GET_PROGRAM_ACTION_ITEMS_ERROR = "GET_PROGRAM_ACTION_ITEMS_ERROR";
export const GET_PROGRAM_ACTION_ITEMS_LOADING = "GET_PROGRAM_ACTION_ITEMS_LOADING";
export const GET_PROGRAM_ANNOUNCEMENTS = "GET_PROGRAM_ANNOUNCEMENTS";
export const GET_PROGRAM_ANNOUNCEMENTS_ERROR = "GET_PROGRAM_ANNOUNCEMENTS_ERROR";
export const GET_PROGRAM_ANNOUNCEMENTS_LOADING = "GET_PROGRAM_ANNOUNCEMENTS_LOADING";
export const SET_PROGRAM_FORM_CONTEXT = "SET_PROGRAM_FORM_CONTEXT";
export const RESET_PROGRAM_FORM_CONTEXT = "RESET_PROGRAM_FORM_CONTEXT";
export const GET_PROGRAM_FORM_CONTEXT_USER_INFO = "GET_PROGRAM_FORM_CONTEXT_USER_INFO";
export const GET_PROGRAM_FORM_CONTEXT_USER_INFO_LOADING = "GET_PROGRAM_FORM_CONTEXT_USER_INFO_LOADING";
export const GET_PROGRAM_FORM_CONTEXT_USER_INFO_ERROR = "GET_PROGRAM_FORM_CONTEXT_USER_INFO_ERROR";
export const GET_ALL_PROGRAMS = "GET_ALL_PROGRAMS";
export const GET_ALL_PROGRAMS_ERROR = "GET_ALL_PROGRAMS_ERROR";
export const GET_ALL_PROGRAMS_LOADING = "GET_ALL_PROGRAMS_LOADING";
export const GET_SINGLE_PROGRAM = "GET_SINGLE_PROGRAM";
export const GET_SINGLE_PROGRAM_ERROR = "GET_SINGLE_PROGRAM_ERROR";
export const GET_POST_ERROR = "GET_POST_ERROR";
export const GET_POST_LOADING = "GET_POST_LOADING";
export const GET_SINGLE_PROGRAM_LOADING = "GET_SINGLE_PROGRAM_LOADING";
export const UPDATE_PROGRAM_FORM = "UPDATE_PROGRAM_FORM";
export const UPDATE_PROGRAM_FORM_LOADING = "UPDATE_PROGRAM_FORM_LOADING";
export const UPDATE_PROGRAM_FORM_ERROR = "UPDATE_PROGRAM_FORM_ERROR";
export const GET_PROGRAM_TEAMS = "GET_PROGRAM_TEAMS";
export const GET_PROGRAM_TEAMS_LOADING = "GET_PROGRAM_TEAMS_LOADING";
export const GET_PROGRAM_TEAMS_ERROR = "GET_PROGRAM_TEAMS_ERROR";
export const REMOVE_TEAM = "REMOVE_TEAM";
export const REMOVE_TEAM_LOADING = "REMOVE_TEAM_LOADING";
export const REMOVE_TEAM_ERROR = "REMOVE_TEAM_ERROR";
export const SAVE_TEAM = "SAVE_TEAM";
export const SAVE_TEAM_ERROR = "SAVE_TEAM_ERROR";
export const SAVE_TEAM_LOADER = "SAVE_TEAM_LOADER";
export const GET_PROGRAM_TEAM_USERS = "GET_PROGRAM_TEAM_USERS";
export const GET_PROGRAM_TEAM_USERS_LOADING = "GET_PROGRAM_TEAM_USERS_LOADING";
export const GET_PROGRAM_TEAM_USERS_ERROR = "GET_PROGRAM_TEAM_USERS_ERROR";
export const GET_PROGRAM_CHANNEL_POST_LIST = "GET_PROGRAM_CHANNEL_POST_LIST";
export const CLEAR_PROGRAM_CHANNEL_POST_LIST = 'CLEAR_PROGRAM_CHANNEL_POST_LIST';
export const GET_CHANNEL_POST_DETAILS = "GET_CHANNEL_POST_DETAILS";
export const GET_ACTIVE_CHANNELS = "GET_ACTIVE_CHANNELS";
export const GET_SUBSCRIBE_CHANNELS="GET_SUBSCRIBE_CHANNELS";
export const COMMUNITY_ROLES_FETCH_REQUEST = 'COMMUNITY_ROLES_FETCH_REQUEST';
export const COMMUNITY_ROLES_FETCH_SUCCESS = 'COMMUNITY_ROLES_FETCH_SUCCESS';
export const COMMUNITY_ROLES_FETCH_FAILURE = 'COMMUNITY_ROLES_FETCH_FAILURE';
export const COMMUNITY_ROLES_UPDATE_REQUEST = 'COMMUNITY_ROLES_UPDATE_REQUEST';
export const COMMUNITY_ROLES_UPDATE_SUCCESS = 'COMMUNITY_ROLES_UPDATE_SUCCESS';
export const COMMUNITY_ROLES_UPDATE_FAILURE = 'COMMUNITY_ROLES_UPDATE_FAILURE';
export const START_LOADING='START_LOADING'
export const CLOSE_LOADING='CLOSE_LOADING'
//program Enrollment Actions
export const GET_USER_PROGRAM_ENROLLMENT = 'GET_USER_PROGRAM_ENROLLMENT';
export const GET_USER_PROGRAM_ENROLLMENT_ERROR = 'GET_USER_PROGRAM_ENROLLMENT_ERROR';
export const GET_USER_PROGRAM_ENROLLMENT_LOADING = 'GET_USER_PROGRAM_ENROLLMENT_LOADING';
export const SET_ACTIVE_PHASE_NUMBER = "SET_ACTIVE_PHASE_NUMBER";
export const CLOSE_USER_PROGRAM_ENROLLMENT_LOADING = "CLOSE_USER_PROGRAM_ENROLLMENT_LOADING";
export const PROGRAM_INFO_POPUP_OPENED='PROGRAM_INFO_POPUP_OPENED'

//program Form Action
export const GET_PROGRAM_FORM_STRUCTURE = 'GET_PROGRAM_FORM_STRUCTURE';
export const GET_PROGRAM_FORM_STRUCTURE_CACHE = 'GET_PROGRAM_FORM_STRUCTURE_CACHE';
export const GET_PROGRAM_FORM_STRUCTURE_ERROR = 'GET_PROGRAM_FORM_STRUCTURE_ERROR';
export const GET_PROGRAM_FORM_STRUCTURE_LOADING = 'GET_PROGRAM_FORM_STRUCTURE_LOADING';
export const GET_PROGRAM_FORM_CONTEXT_DATA = 'GET_PROGRAM_FORM_CONTEXT_DATA';
export const GET_PROGRAM_FORM_CONTEXT_CACHE = 'GET_PROGRAM_FORM_CONTEXT_DATA_CACHE';
export const GET_PROGRAM_FORM_CONTEXT_DATA_ERROR = 'GET_PROGRAM_FORM_CONTEXT_DATA_ERROR';
export const GET_PROGRAM_FORM_CONTEXT_DATA_LOADING = 'GET_PROGRAM_FORM_CONTEXT_DATA_LOADING';
export const GET_PROGRAM_CONTEXT_LIST = 'GET_PROGRAM_CONTEXT_LIST';
export const GET_PROGRAM_CONTEXT_LIST_ERROR = 'GET_PROGRAM_CONTEXT_LIST_ERROR';
export const GET_PROGRAM_CONTEXT_LIST_LOADING = 'GET_PROGRAM_CONTEXT_LIST_LOADING';
export const RESET_USER_FORM_DATA = "RESET_USER_FORM_DATA";
export const RESET_PROGRAM_FORM_STRUCTURE = "RESET_PROGRAM_FORM_STRUCTURE";
export const OPEN_PROGRAM_FORM_MODAL = "OPEN_PROGRAM_FORM_MODAL";
export const CLOSE_PROGRAM_FORM_MODAL = "CLOSE_PROGRAM_FORM_MODAL";

//team Action
export const GET_TEAM = 'GET_TEAM';
export const GET_TEAM_ERROR = 'GET_TEAM_ERROR';
export const GET_TEAM_LOADER = 'GET_TEAM_LOADING';
export const TEAM_USER_SUCCESS = 'TEAM_USER_SUCCESS';
export const TEAM_USERS_STATE = 'TEAM_USERS_STATE';
export const PENDING_TEAM_STATUS = 'PENDING_TEAM_STATUS';
export const TEAM_USERS = 'TEAM_USERS';
export const GET_TEAM_USER_LOADER = 'GET_TEAM_USER_LOADER';
export const GET_USER_POLICY_LOADING = 'GET_USER_POLICY_LOADING';
export const USER_POLICY = 'USER_POLICY';
export const USER_STATUS_ERROR = 'USER_STATUS_ERROR';
export const TEAM_USER_CREATE = 'TEAM_USER_CREATE';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const CHANGE_USER_PASSWORD_ERROR = 'CHANGE_USER_PASSWORD_ERROR';
export const CHANGE_USER_PASSWORD_LOADER = 'CHANGE_USER_PASSWORD_LOADER';
export const GET_ALL_TEAMS = 'GET_ALL_TEAMS';
export const GET_ALL_TEAMS_ERROR = 'GET_ALL_TEAMS_ERROR';
export const GET_ALL_TEAMS_LOADER = 'GET_ALL_TEAMS_LOADER';
export const ARCHIVE_USER = 'ARCHIVE_USER';
export const ARCHIVE_USER_ERROR = 'ARCHIVE_USER_ERROR';
export const ARCHIVE_USER_LOADER = 'ARCHIVE_USER_LOADER';
export const SELECTED_POST_MENU='SELECTED_POST_MENU'

// Test Management Actions
export const TEST_RUNS_FETCH_REQUEST = 'TEST_RUNS_FETCH_REQUEST';
export const TEST_RUNS_FETCH_SUCCESS = 'TEST_RUNS_FETCH_SUCCESS';
export const TEST_RUNS_FETCH_FAILURE = 'TEST_RUNS_FETCH_FAILURE';
export const TEST_RUN_FETCH_REQUEST = 'TEST_RUN_FETCH_REQUEST';
export const TEST_RUN_FETCH_SUCCESS = 'TEST_RUN_FETCH_SUCCESS';
export const TEST_RUN_FETCH_FAILURE = 'TEST_RUN_FETCH_FAILURE';
export const TEST_RUN_CLEANUP_REQUEST = 'TEST_RUN_CLEANUP_REQUEST';
export const TEST_RUN_CLEANUP_SUCCESS = 'TEST_RUN_CLEANUP_SUCCESS';
export const TEST_RUN_CLEANUP_FAILURE = 'TEST_RUN_CLEANUP_FAILURE';
export const TEST_SPEED_FETCH_SUCCESS = 'TEST_SPEED_FETCH_SUCCESS';
export const TEST_SPEED_UPDATE_SUCCESS = 'TEST_SPEED_UPDATE_SUCCESS';
export const TEST_PROGRAMS_FETCH_SUCCESS = 'TEST_PROGRAMS_FETCH_SUCCESS';

// Analytics Actions
export const ANALYTICS_OVERVIEW_REQUEST = 'ANALYTICS_OVERVIEW_REQUEST';
export const ANALYTICS_OVERVIEW_SUCCESS = 'ANALYTICS_OVERVIEW_SUCCESS';
export const ANALYTICS_OVERVIEW_FAILURE = 'ANALYTICS_OVERVIEW_FAILURE';
export const ANALYTICS_CHANNELS_REQUEST = 'ANALYTICS_CHANNELS_REQUEST';
export const ANALYTICS_CHANNELS_SUCCESS = 'ANALYTICS_CHANNELS_SUCCESS';
export const ANALYTICS_CHANNELS_FAILURE = 'ANALYTICS_CHANNELS_FAILURE';
export const ANALYTICS_USERS_REQUEST = 'ANALYTICS_USERS_REQUEST';
export const ANALYTICS_USERS_SUCCESS = 'ANALYTICS_USERS_SUCCESS';
export const ANALYTICS_USERS_FAILURE = 'ANALYTICS_USERS_FAILURE';
export const ANALYTICS_CHANNEL_DETAIL_REQUEST = 'ANALYTICS_CHANNEL_DETAIL_REQUEST';
export const ANALYTICS_CHANNEL_DETAIL_SUCCESS = 'ANALYTICS_CHANNEL_DETAIL_SUCCESS';
export const ANALYTICS_CHANNEL_DETAIL_FAILURE = 'ANALYTICS_CHANNEL_DETAIL_FAILURE';
export const ANALYTICS_USER_DETAIL_REQUEST = 'ANALYTICS_USER_DETAIL_REQUEST';
export const ANALYTICS_USER_DETAIL_SUCCESS = 'ANALYTICS_USER_DETAIL_SUCCESS';
export const ANALYTICS_USER_DETAIL_FAILURE = 'ANALYTICS_USER_DETAIL_FAILURE';

// Content Logs Actions
export const CONTENT_LOGS_DIR_FETCH_REQUEST = 'CONTENT_LOGS_DIR_FETCH_REQUEST';
export const CONTENT_LOGS_DIR_FETCH_SUCCESS = 'CONTENT_LOGS_DIR_FETCH_SUCCESS';
export const CONTENT_LOGS_DIR_FETCH_FAILURE = 'CONTENT_LOGS_DIR_FETCH_FAILURE';
export const CONTENT_LOGS_FILE_FETCH_REQUEST = 'CONTENT_LOGS_FILE_FETCH_REQUEST';
export const CONTENT_LOGS_FILE_FETCH_SUCCESS = 'CONTENT_LOGS_FILE_FETCH_SUCCESS';
export const CONTENT_LOGS_FILE_FETCH_FAILURE = 'CONTENT_LOGS_FILE_FETCH_FAILURE';
